import { atom } from 'jotai';

export const showAskXResultState = atom<boolean>(false);
